<mat-form-field
  class="munily-filter-select-field"
  appearance="outline"
  [floatLabel]="floatLabel"
  [class.munily-filter-select-field--size-large]="size === 'large'"
  [class.munily-filter-select-field--size-small]="size === 'small'"
  [class.munily-filter-select-field--has-value]="showClearButton()"
  [class.munily-filter-select-field--success]="showSuccessOutline()"
  [class.mat-form-field-invalid]="showError()"
>
  <mat-label *ngIf="label">{{ label }}</mat-label>

  <mat-icon
    *ngIf="iconLeading"
    matPrefix
    class="munily-ff-icon material-symbols-rounded"
    aria-hidden="true"
  >
    {{ iconLeading }}
  </mat-icon>

  <mat-select
    [formControl]="resolvedControl"
    [multiple]="multiple"
    [panelClass]="panelClass"
    [disableOptionCentering]="disableOptionCentering"
    [compareWith]="compareWith"
    [placeholder]="placeholder"
    (selectionChange)="onSelectionChange($event)"
    (openedChange)="onOpenedChange($event)"
  >
    <mat-option *ngFor="let opt of options" [value]="opt.value">
      <ng-container [ngSwitch]="!!opt.labelKey">
        <span *ngSwitchCase="true">{{ opt.labelKey | translate }}</span>
        <span *ngSwitchDefault>{{ opt.label }}</span>
      </ng-container>
    </mat-option>
  </mat-select>

  <span
    *ngIf="showClearButton()"
    matSuffix
    class="munily-filter-select-clear"
    (mousedown)="onClearPointerDown($event)"
  >
    <common-icon-button
      variant="plain"
      icon="cancel"
      [iconFill]="true"
      [ariaLabel]="clearAriaLabel"
      [stopClickPropagation]="true"
      (output)="onClear()"
    ></common-icon-button>
  </span>

  <mat-hint *ngIf="hint">{{ hint }}</mat-hint>
  <mat-error *ngIf="showError()">{{ resolvedErrorMessage }}</mat-error>
</mat-form-field>
